import type { ImageSlot } from '@/types'

export type SignatureDish = {
    name: string
    description: string
    price: string
    image: ImageSlot
}

export const SIGNATURE_DISHES: Array<SignatureDish> = [
    {
        name: "Charcoal-lacquered lamb rack",
        description: "Glazed over the coals until the lacquer catches, with pomegranate jus.",
        price: '42',
        image: { src: '/images/dishes/lamb-rack.jpg', caption: "Lamb rack, pomegranate jus", alt: "Charcoal-lacquered lamb rack with pomegranate jus", tone: 'ember', motif: 'plate' }
    },
    {
        name: "Whole grilled sea bream",
        description: "Grilled on the bone, with beurre blanc and wild herbs.",
        price: '38',
        image: { src: '/images/dishes/sea-bream.jpg', caption: "Sea bream, beurre blanc", alt: "Whole grilled sea bream with beurre blanc and wild herbs", tone: 'smoke', motif: 'plate' }
    },
    {
        name: "Chicken supreme",
        description: "Crisp skin, smoked yogurt and charred tomato.",
        price: '29',
        image: { src: '/images/dishes/chicken-supreme.jpg', caption: "Chicken supreme, smoked yogurt", alt: "Chicken supreme with smoked yogurt and charred tomato", tone: 'ember', motif: 'plate' }
    },
    {
        name: "Wood-fired cauliflower",
        description: "Roasted whole in the oak oven, with tahini and burnt honey.",
        price: '22',
        image: { src: '/images/dishes/cauliflower.jpg', caption: "Cauliflower, tahini, burnt honey", alt: "Wood-fired cauliflower with tahini and burnt honey", tone: 'stone', motif: 'plate' }
    },
    {
        name: "Hand-minced beef kofta",
        description: "Minced by hand, grilled fast, with pickled chili.",
        price: '26',
        image: { src: '/images/dishes/kofta.jpg', caption: "Beef kofta, pickled chili", alt: "Hand-minced beef kofta with pickled chili", tone: 'ember', motif: 'plate' }
    }
]
